import { tApi } from 'tplus-api';

export default class ProductApi {
  static async loadInventoryClass(IdStore = '', posCode = '') {
    let filter = { IdStore, posCode };
    let result = await tApi({ filter }, 'chanjet.AA.DR.NewRetailBaseInfo.LoadInventoryClass', false, false);
    return result;
  }
  static async searchInventory(filter) {
    let result = await tApi({ filter }, 'chanjet.AA.DR.NewRetailBaseInfo.SearchInventory', false, false);
    return result;
  }
}